import Tabs from './component';

export default Tabs;
